const rolesTypes = {
	USER: "USER",
	USER_RESTRICTED: "USER_RESTRICTED",
	AGENT: "AGENT",
	ADMIN: "ADMIN",
};
const roles = Object.keys(rolesTypes);

module.exports = { rolesTypes, roles };
